import React from "react";

const Java_Class = () => {
  return (
    <div>
      <h1>Java Class</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Class in Java.</p>
    </div>
  );
};

export default Java_Class;
